<template>
  <div class="content">
      <!-- 搜索区 -->
      <el-card class="box-card">
        <el-form>
          <el-input class="card-input" v-model="iccid" autocomplete="on" name="iccid" style="width: 20%"
                    placeholder="请输入ICCID" clearable ></el-input>
          <el-button class="card-search" type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        </el-form>
      </el-card>
      <!-- 卡信息 -->
      <el-card class="box-card" v-if="cardData.iccid">
        <!-- <div v-if="!cardData.iccid" class="default-card-info">暂无数据</div> -->
        <el-descriptions  :column="4" :contentStyle="{'font-size': '15px'}" :labelStyle="{'font-weight': 'bold','color':'#303133'}">
          <el-descriptions-item label="ICCID">{{cardData.iccid}}</el-descriptions-item>
          <el-descriptions-item label="MSISDN">{{cardData.msisdn}}</el-descriptions-item>
          <el-descriptions-item label="代理商">{{cardData.company}}</el-descriptions-item>
          <el-descriptions-item :label="cardData.name">{{cardData.cardStatus}}</el-descriptions-item>
          <el-descriptions-item label="状态">{{cardData.showStatus}}</el-descriptions-item>
          <el-descriptions-item v-if="adminShow" label="IMEI号">{{cardData.imei}}</el-descriptions-item>
          <el-descriptions-item label="运营商">{{cardData.operationName}}</el-descriptions-item>
          <el-descriptions-item v-if="adminShow" label="卡源">{{cardData.cardSourceName}}</el-descriptions-item>
          <el-descriptions-item v-if="adminShow" label="GPRS">{{cardData.gprsStatus}}</el-descriptions-item>
          <el-descriptions-item label="当月流量">{{cardData.monthFlow}}</el-descriptions-item>
          <el-descriptions-item v-if="adminShow" label="积分">{{cardData.integral}}</el-descriptions-item>
          <el-descriptions-item label="开启同步">{{cardData.sync}}</el-descriptions-item>
          <el-descriptions-item v-if="adminShow" label="实名状态">{{cardData.kycStatus}}</el-descriptions-item>
          <el-descriptions-item v-if="adminShow" label="在线状态">{{cardData.online}}</el-descriptions-item>
          <el-descriptions-item v-if="adminShow" label="手机号">{{cardData.phone}}</el-descriptions-item>
          <el-descriptions-item v-if="adminShow" label="限速状态" >{{cardData.speedStatus}}</el-descriptions-item>
          <el-descriptions-item label="同步时间">{{cardData.syncTime}}</el-descriptions-item>
          <el-descriptions-item v-if="adminShow" label="开户时间" >{{cardData.openTime}}</el-descriptions-item>
          <el-descriptions-item v-if="adminShow" label="分配时间">{{cardData.lastAdminTransferTime}}</el-descriptions-item>
          <el-descriptions-item v-if="adminShow" label="销户时间" >{{cardData.delTime}}</el-descriptions-item>
          <el-descriptions-item label="套餐激活时间">{{cardData.activeTime}}</el-descriptions-item>
          <el-descriptions-item label="套餐过期时间">{{cardData.expireTime}}</el-descriptions-item>
          <el-descriptions-item v-if="adminShow" label="自动续费" >{{cardData.hasAgreement}}</el-descriptions-item>
          <el-descriptions-item v-if="adminShow" label="卡过期时间" >{{cardData.realExpireTime}}</el-descriptions-item>
          <el-descriptions-item v-if="cardData.mode == 1" label="池名称" >{{cardData.poolName}}</el-descriptions-item>
          <el-descriptions-item v-if="cardData.mode == 1" label="池峰值">{{cardData.poolLimit}}</el-descriptions-item>
          <el-descriptions-item v-if="cardData.mode == 1" label="池模式" >{{cardData.poolType}}</el-descriptions-item>
          <el-descriptions-item v-if="cardData.mode == 1" label="池创建时间" >{{cardData.poolStartTime}}</el-descriptions-item>
          <el-descriptions-item v-if="cardData.mode == 1" label="池到期时间" >{{cardData.poolEndTime}}</el-descriptions-item>
        </el-descriptions>
      </el-card>
      <!-- 卡操作区 -->
      <el-card class="box-card" v-if="cardData.iccid">
        <div class="box-card-operation">
          <div class="card-removal">
            <el-button type="success" size="medium" v-hasPermi="['card:clear']"  @click="submitRemovalForm()" >卡清除</el-button>
          </div>
          <div class="removal-message">
            <span>{{message}}</span>
          </div> 
        </div>
      </el-card>
      <!-- 列表 -->
      <el-card class="box-card" style="margin-top:6px" v-if="cardData.iccid">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="流量资费列表" name="second"  v-if="checkPermi(['card:info:cardProduct'])">
              <cardJftc ref="second" :iccid="iccid"></cardJftc>
            </el-tab-pane>
            <el-tab-pane label="订单列表" name="third" v-if="checkPermi(['card:info:orderList'])">
              <cardOrderList ref="third" :iccid="iccid"></cardOrderList>
            </el-tab-pane>
            <el-tab-pane label="操作列表" name="fourth" v-if="checkPermi(['card:info:cardRemovalOperationList'])">
              <cardRemovalOperationList ref="fourth" :iccid="iccid"></cardRemovalOperationList>
            </el-tab-pane>
          </el-tabs>
      </el-card>
  </div>
</template>
<script>
import cardJftc from "@/components/cardDetails/cardJftc.vue";
import cardOrderList from "@/components/cardDetails/cardOrderList.vue";
import cardRemovalOperationList from "@/components/cardDetails/cardRemovalOperationList.vue";

import {cardDetail, removalCardByIccid} from "@/api/api.js";
export default {
  name:'cardOperation',
  data() {
    return {
      iccid : undefined,
      activeName: "second",
      message:"",
      cardLock:"未知",
      cardData:{},
      dialog:false,
    };
  },
  computed: {
    adminShow : {
      get() {
        return this.$store.getters.user.userType =='1'
      }
    }
  },
  components: {
    cardJftc,
    cardOrderList,
    cardRemovalOperationList,
  },
  methods: {
    // 搜索
    search() {
      this.message = "";
      if(!this.iccid){
        return false
      }
      this.initData();
      
    },
    handleClick(tab) {
      if(!this.iccid){
        return false
      }
      this.$refs[tab.name].initData()
    },
    transferFlowRatio(status) {
      let obj = {
        1: "库存",
        2: "待激活",
        3: "可测试",
        4: "已激活",
        5: "已停机",
        6: "预销户",
        7: "已销户",
        8: "停机保号",
        9: "已补卡",
      };
      return obj[status];
    },
    realnamestatus(status) {
      let obj = {
        0: "未实名 ",
        1: "实名中",
        2: "已实名",
        3: "未通过",
        4: "已注销",
      };
      return obj[status];
    },
    // 初始化数据
    initData() {
      if(!this.iccid){
        return false
      }
      let params ={
        iccid : this.iccid
      }
      cardDetail(params).then(res => {
          this.cardData = res.data.data;
          if(!this.cardData.iccid){
            this.$message({
              type: 'error',
              message: '卡号不存在，请重新输入!'
            });
          }else{
            this.cardData.kycStatus = this.realnamestatus(this.cardData.kycStatus);
            this.cardData.sync = this.cardData.sync == "开启" ? "已开启" : "未开启";
            this.cardData.gprsStatus = this.cardData.gprsStatus == "开启" ? "已开启" : "未开启";
            this.cardData.speedStatus = this.cardData.speedStatus == 0 ? "未限速" : "已限速";
            this.cardData.monthFlow = this.cardData.monthFlow == null ? "无" : this.cardData.monthFlow + "M";
            this.cardData.remark = this.cardData.remark == null || this.cardData.remark == "" ? "无" : this.cardData.remark;
            this.cardData.openTime = this.cardData.openTime == null ? "无" : this.cardData.openTime;
            this.cardData.lastAdminTransferTime = this.cardData.lastAdminTransferTime == null ? "无" : this.cardData.lastAdminTransferTime;
            this.cardData.delTime = this.cardData.delTime == null ? "无" : this.cardData.delTime;
            this.cardData.activeTime = this.cardData.activeTime == null ? "无" : this.cardData.activeTime;
            this.cardData.expireTime = this.cardData.expireTime == null ? "无" : this.cardData.expireTime;
            this.cardData.phone = this.cardData.phone == null || this.cardData.phone == "" ? "无" : this.cardData.phone;
            this.cardData.company = this.cardData.company == null ? "未分配" : this.cardData.company;
            this.cardData.companyNameLevel = this.cardData.companyNameLevel == null ? "未分配" : this.cardData.companyNameLevel;
            this.cardData.imei = this.cardData.imei == null ? "无" : this.cardData.imei;
            this.cardData.hasAgreement = this.cardData.hasAgreement == 0 ? "未签约" : "已签约";
            switch (this.cardData.online) {
              case "online":
                this.cardData.online = "在线";
                break;
              case "offline":
                this.cardData.online = "不在线";
                break;
              case "unknown":
                this.cardData.online = "未查询到会话信息";
                break;
              case null:
                this.cardData.online = "未查询";
                break;
            }
            // 运营状态--运营商状态真的
            // 状态--公众号展示状态假的
            if(this.adminShow){
              this.cardData.name = '运营状态';
              this.cardData.cardStatus = this.transferFlowRatio(this.cardData.cardStatus);
              this.cardData.showStatus = this.transferFlowRatio(this.cardData.showStatus);
            }else{
              this.cardData.showStatus = this.transferFlowRatio(this.cardData.showStatus);
              this.cardData.name = 'IMSI';
              this.cardData.cardStatus = "无";
              this.cardData.cardSourceName = "无";
              this.cardData.gprsStatus = "已开启";
              if(this.cardData.hasEnjoy == "1"){
                this.cardData.monthFlow = "畅享"
              }
            };
            this.$refs[this.activeName] && this.$refs[this.activeName].initData()
          }
          
      }).catch((res) => {
          this.cardData = {}
      });;
    },
    //清除卡提交
    submitRemovalForm(){
      if (!this.cardData.iccid) {
        this.message = "ICCID不能为空";
      } else {
        this.$confirm('确定清除ICCID:'+ this.cardData.iccid +'的套餐和订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          removalCardByIccid({iccid:this.iccid}).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.openRemoval = false;
            this.search()
          }).catch((res) => {
            this.message = res.message;
          });
        })
        
      }
    },
  },
  created() {
  },
  mounted() {
    
  },
};
</script>
<style scoped lang="less">
  .card-input{
    margin-right: 10px;
  }
  .cardContent{
    padding: 0 20px;
  }
  .box-card-operation{
    display: flex;
    align-items: center;
    .removal-message{
      align-self: flex-end;
      font-size: 14px;
      margin-left: 10px;
      color:red;
    }
  }
  
  .default-card-info{
    line-height: 30px;
    font-size: 14px;
    width: 100%;
    color: #909399;
    text-align: center;
  }
</style>